import React from 'react';
import { Checkins } from '../Checkins';
export var BlockCheckins = function (_a) {
    var lines = _a.lines;
    return (React.createElement(Checkins, { lines: lines }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockCheckins.tsx
// module id = 254
// module chunks = 0